import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

const VueRouterReplace = Router.prototype.replace;
Router.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch((err) => err);
};

function routerComponent(rout) {
  return () => import(`@/components/${rout}/${rout}`);
}

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  // mode: 'history',
  routes: [
    {
      path: "",
      name: "index",
      redirect: "/user", //首页重定向
      component: () => import(`@/components/index/index`),
      children: [
        {
          path: "user",
          name: "user",
          component: () => import(`@/components/user/user`),
        },
        {
          path: "company",
          name: "company",
          component: () => import(`@/components/company/company`),
        },
        {
          path: "role",
          name: "role",
          component: () => import(`@/components/role/role`),
        },
        {
          path: "platform",
          name: "platform",
          component: () => import(`@/components/platform/platform`),
        },
        {
          path: "auth",
          name: "auth",
          component: () => import(`@/components/auth/auth`),
        },
        {
          path: "department",
          name: "department",
          component: () => import(`@/components/department/department`),
        },
        {
          path: "position",
          name: "position",
          component: () => import(`@/components/position/position`),
        },
        {
          path: "action",
          name: "action",
          component: () => import(`@/components/action/index`),
        },
        {
          path: "500",
          name: "500",
          component: () => import(`@/view/error/500`),
        },
        {
          path: "404",
          name: "404",
          component: () => import(`@/view/error/404`),
        },
      ],
    },
    { path: "*", redirect: "/404" },
  ],
});
